module.exports = __webpack_public_path__ + "img/zh_table1.062814b3.png";